import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const redoTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "redo",
    onDone: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: [
        "expandRelatedSections",
        assign((_ctx, evt) => ({
          studyPlan: evt.data.plan
        }))
      ]
    },
    onError: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("redo", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
